import { gsap } from "gsap"

function threeVideoLayoutPauseAnimation({ videoRefs, linksRefs, textRefs }) {
  gsap
    .timeline()
    .addLabel("start")
    .to(
      videoRefs.map(ref => ref.current),
      {
        autoAlpha: 0.25,
      },
      "start+=.1"
    )
    .to(
      linksRefs.map(ref => ref.current),
      {
        autoAlpha: 1,
      },
      "start+=.1"
    )
    .to(
      [textRefs[0].current, textRefs[2].current],
      {
        autoAlpha: 0,
        x: 480,
      },
      "start"
    )
    .to(
      [textRefs[1].current, textRefs[3].current],
      {
        autoAlpha: 0,
        x: -480,
      },
      "start"
    )
}

export default threeVideoLayoutPauseAnimation
